// import router from 'vue-router'
import axios from 'axios';
import Vue from 'vue';

const actions = {
    getAll: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/leave-requests', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            commit('setLeaveRequests', res.data.data)
            return res
          }).catch((err) => {
            return err
        });
    },
    getLeaveRequests: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/leave-requests', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            commit('setLeaveRequests', res.data.data)
            return res
          }).catch((err) => {
            return err
        });
    },
    get: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/leave-request/' + payload.id, {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments
                }
            }
          ).then(res => {
            commit('setLeaveRequest', res.data.data)
            return res
          }).catch((err) => {
            return err
        });
    },
    update: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const leaveRequest = payload.leaveRequest;
        const id = payload.id;

        return axios.patch(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/leave-request/' + id, 
            {
                ...leaveRequest
            },
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments
                }
            }
          ).then(res => {
            commit('setLeaveRequest', res.data.data)
            return res
          }).catch((err) => {
            return err
        });
    },
}

export default actions
